"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _errormessages = _interopRequireDefault(require("./helpers/errormessages"));

var _getucnid = _interopRequireDefault(require("./helpers/getucnid"));

var _getusercontext = _interopRequireDefault(require("./helpers/getusercontext"));

/**
 * Given a url, parses the query parameter to retrieve the contextId, and queries Customizr with the contextId
 * @param {string} url - the url to fetch the context from (optional, if not specified, detected from the browser)
 * @param {string} accessToken - the access token of the user
 * @returns an object containing the context or an error describing how the call failed
 */
var fetchContext = /*#__PURE__*/function () {
  var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(_ref) {
    var url, accessToken, _getUcnId, ucnId, isValidUrl;

    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            url = _ref.url, accessToken = _ref.accessToken;
            _getUcnId = (0, _getucnid["default"])({
              url: url
            }), ucnId = _getUcnId.ucnId, isValidUrl = _getUcnId.isValidUrl; // If the passed in URL isn't valid, return an error.

            if (isValidUrl) {
              _context.next = 4;
              break;
            }

            return _context.abrupt("return", {
              error: {
                message: _errormessages["default"].urlNotValid
              }
            });

          case 4:
            if (ucnId) {
              _context.next = 6;
              break;
            }

            return _context.abrupt("return", {
              error: {
                message: _errormessages["default"].ucnIdNotFound
              }
            });

          case 6:
            _context.next = 8;
            return (0, _getusercontext["default"])({
              ucnId: ucnId,
              accessToken: accessToken
            });

          case 8:
            return _context.abrupt("return", _context.sent);

          case 9:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fetchContext(_x) {
    return _ref2.apply(this, arguments);
  };
}();

var _default = fetchContext;
exports["default"] = _default;